import { ComponentsModule } from './../../components/components.module';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MeetingAreasPage } from './meeting-areas';

@NgModule({
  declarations: [
    MeetingAreasPage
  ],
  imports: [
    IonicPageModule.forChild(MeetingAreasPage),
    ComponentsModule
  ],
})
export class MeetingAreasPageModule {}



// WEBPACK FOOTER //
// ./src/pages/meeting-areas/meeting-areas.module.ts